import React from 'react';

import { AppleMusicUrl as AppleMusicUrlForm } from '@/components/Layout/components/AddCustomSong/AppleMusicUrl';

import { IPropsSongModalDisplay } from '../SongModalPanel';

export const AppleMusicUrl: React.FC<IPropsSongModalDisplay> = ({
	openedSong,
	updateTeamSong,
	popDisplayState,
}) => {
	return (
		<AppleMusicUrlForm
			teamSong={openedSong}
			onSubmit={({ appleMusicId }) => {
				updateTeamSong({ appleMusicId });
				popDisplayState();
			}}
		/>
	);
};
